/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { PrinterRestService } from '@gh/builder-shared-data';
import { InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { map$ } from '@gh/rx/operators';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { Printer, Printers } from './model/system-vars.model';

export interface PrinterDetailsDialogConfig {
  printer?: Printer;
}

@Injectable()
export class SystemVarsPrinterListTabBusinessService implements InitViewService {
  constructor(private printerRest: PrinterRestService) {

  }

  initView(): any {
    return this.findAll();
  }

  findAll(): Observable<Printers> {
    return this.printerRest.findAll();
  }

  changePrintType(isCloud: boolean): Observable<void> {
    return this.printerRest.changePrintType(isCloud);
  }

  create(printer: Printer): Observable<Printer> {
    return this.printerRest.create(printer);
  }

  update(printer: Printer): Observable<Printer> {
    return this.printerRest.update(printer);
  }

  remove(printerId: ID): Observable<void> {
    return this.printerRest.remove(printerId);
  }
}
